export default "__VITE_ASSET__DMnWQYFp__"